import {
  GET_SEARCH_PRODUCT_DL_REQUEST,
  GET_SEARCH_PRODUCT_DL_SUCCESS,
  GET_SEARCH_PRODUCT_DL_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const searchProductDL = (token, values) => (dispatch) => {
  dispatch({ type: GET_SEARCH_PRODUCT_DL_REQUEST });
  const newData = {
    sku: values.sku
};
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/SearchProductDL`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_SEARCH_PRODUCT_DL_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SEARCH_PRODUCT_DL_ERROR,
        payload: [],
      });
    });
};